import React, { useCallback, useEffect, useState } from 'react';
import { NodeProps, NodeResizer } from '@xyflow/react';
import { useDispatch } from 'react-redux';
import { TbTrash } from 'react-icons/tb';
import { updateNodeData, removeNode } from '../../../store/workflow/workflowSlice';
import styles from './WorkflowNode.module.css';
import i18n from '../../../i18n';
import { typeLabelOf } from '../nodeCatalog';

/**
 * 메모 노드 (분류 etc) — 캔버스 위의 포스트잇. 실행 태스크가 아니며 DAG 변환 시 무시된다.
 * 본문을 노드 안에서 바로 편집하고(속성 패널에서도 편집 가능), 모서리로 크기를 조절한다. 연결 핸들은 없다.
 */
const MemoNode = ({ id, data, selected }: NodeProps) => {
  const dispatch = useDispatch();
  const cfg = ((data as any)?.config || {}) as { text?: string };
  const [text, setText] = useState<string>(cfg.text || '');
  useEffect(() => { setText(cfg.text || ''); }, [cfg.text]);

  const commit = useCallback(() => {
    if ((cfg.text || '') !== text) {
      dispatch(updateNodeData({ id, data: { config: { ...(data as any)?.config, text } } } as any));
    }
  }, [cfg.text, text, dispatch, id, data]);

  const handleDelete = (e: React.MouseEvent) => { e.stopPropagation(); dispatch(removeNode(id)); };

  return (
    <div
      className={`memo-node relative rounded-md border shadow-md flex flex-col ${selected ? 'memo-node--selected' : ''}`}
      style={{ width: '100%', height: '100%', minWidth: 160, minHeight: 90 }}
    >
      <NodeResizer minWidth={160} minHeight={90} isVisible={selected} handleStyle={{ background: '#f59e0b' }} lineStyle={{ background: '#f59e0b' }} />
      <div style={{ position: 'absolute', top: -16, right: -16, zIndex: 20 }}>
        {TbTrash({ className: styles.trashIcon, onClick: handleDelete, title: i18n.t('workflow:memo.delete') })}
      </div>
      <div className="memo-node__title px-2 pt-1.5 pb-0.5 text-xs font-semibold truncate select-none">
        {String((data as any)?.label || typeLabelOf('memo'))}
      </div>
      <textarea
        className="memo-node__text nodrag nowheel flex-1 w-full resize-none bg-transparent px-2 pb-2 text-sm leading-5 outline-none"
        value={text}
        placeholder={i18n.t('workflow:memo.placeholder')}
        onChange={(e) => setText(e.target.value)}
        onBlur={commit}
        onMouseDown={(e) => e.stopPropagation()}
        spellCheck={false}
      />
    </div>
  );
};

export default React.memo(MemoNode);
